import { render, staticRenderFns } from "./BAttributeEditorComponent.vue?vue&type=template&id=79a4711c&scoped=true"
import script from "./BAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./BAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a4711c",
  null
  
)

export default component.exports